var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center h-80"},[_c('div',{staticClass:"row",attrs:{"align":"center"}},[_c('div',{ref:"twitchVideo",attrs:{"id":"twitch-embed"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }